module.exports = __webpack_public_path__ + "img/cover.22f9aff9.jpg";